import { render, staticRenderFns } from "./fix-fluid-col-grid.vue?vue&type=template&id=f841ced6&scoped=true&"
import script from "./fix-fluid-col-grid.js?vue&type=script&lang=js&"
export * from "./fix-fluid-col-grid.js?vue&type=script&lang=js&"
import style0 from "./fix-fluid-col-grid.scss?vue&type=style&index=0&id=f841ced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f841ced6",
  null
  
)

export default component.exports